'use strict';

function KeepWidthDirective() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs, controller) {
            var width = element.prop('offsetWidth');
            var otherCss = element.css('cssText');
            attrs.$set('style', 'width: ' + width + 'px;' + otherCss);
        }
    };
}

export default KeepWidthDirective;
